import styled from 'styled-components';

export const Container = styled.div`
  padding-left: 3.4em;
  text-indent: -3.4em;
  margin-bottom: 0.5em;
`

export const Year = styled.span`
  font-weight: bold;
  margin-right: 1em;
`
